import Axios from "@/axios-default"
import { i18n } from '@/i18n.js'

const namespaced = true;

const state = () => ({
  loading: false,
  saving: false,
  syncTime: null,
  syncPeriod: 1000 * 60 * 3,
  currentControllerId: null,
  monthN: ['0','01','02','03','04','05','06','07','08','09','10','11','12'],
  show: { temp1: true, temp2: false, temp3: false, temp4: true, temp5: false, temp6: false, temp7: true, temp8: false, temp9: false, temp10: true, temp11: false, temp12: false, temp13: false, temp14: false },
  data: []
});

const getters = {
  show(state) {
    return state.show;
  },
  data(state) {
    return state.data
  },
  loading(state) {
    return state.loading
  }
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading
  },
  setSaving(state, saving) {
    state.saving = saving
  },
  setSyncTime(state, syncTime) {
    state.syncTime = syncTime
  },
  importData(state, data) {
    if (Array.isArray(data)) {
      var lastH = null, h, filteredData = [];
      
      data.forEach(function(el) {
        h = el.date.slice(11, 13);
        if (h != lastH) {
          el.date = h + ':00';
          filteredData.push(el);
        }
        lastH = h;
      });
      
      var transposedData = [], k;

      if (filteredData.length[0]) {
        Object.keys(filteredData[0]).forEach(function (item) {
          if (item != 'date') {
            transposedData[item] = filteredData.map(function (el) {
              return { x: el.date, y: el[item] };
            });
          }
        });
      }

      state.data = transposedData;
    }
  },
  setCurrentCoontroller(state, data) {
    state.currentControllerId = data
  },
  reset(state) {
    state.users = [];
  },
  toggleShow(state, param) {
    state.show[param] = !state.show[param];
  }
};

const actions = {  
  async load ({commit, rootGetters, state}, {controllerId, date}) {
    try {
      //if (!state.loading && (controllerId != state.currentControllerId || state.syncTime === null || new Date().getTime() - state.syncTime > state.syncPeriod)) {
      if (true) {
        if (controllerId != state.currentControllerId) {
          commit('reset');
        }
        
        commit('setLoading', true);
        commit('setCurrentCoontroller', controllerId);
        const formData = new URLSearchParams();
        formData.append('controllerId', controllerId);
        formData.append('token', rootGetters.token);

        var d = date.split('-'),
        //dFormat = d[2] + '.' + state.monthN[d[1]] + '.' + d[0];
        dFormat = d[2] + '.' + state.monthN[parseInt(d[1])] + '.' + d[0];
        formData.append('date', dFormat);
        const res = await Axios.post('/api/sterownik/wykresy/temperatura?t=' + Date.now(), formData);
        if (typeof res.data !== 'object') {
          res.data = {error:{code:'0'}};
        } else {
          commit('setLoading', false);
          commit('importData', res.data);
          if (res.data.length == 0) {
            res.data = {error:{code:'667'}};
          } else {
            commit('setSyncTime', new Date().getTime());
          }
        }
        return res.data;
      } else {
        return { skip: true }
      }
    }
    catch (error) {
      return console.log(error);
    }
  },
  toggleShow({commit}, param){
    commit('toggleShow', param);
  }
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}